
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class ConfirmDialog extends Vue {
  @Prop({ default: false }) readonly value!: boolean;

  @Prop({ required: true }) readonly title!: string;

  @Prop({ default: '' }) readonly body!: string;

  @Prop({ default: '送信' }) readonly confirmLabel!: string;

  @Prop({ default: '' }) readonly transitionLabel!: string;

  @Prop({ default: false }) readonly editable!: boolean;

  @Prop({ default: false }) readonly readOnly!: boolean;
}
